import { useState, useEffect } from "react";
import axios from "axios";
import { API_CONFIG } from "../utils/constants";

/**
 * Hook para obtener estadísticas de rendimiento y auditoría
 */
export const usePerformanceStats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_CONFIG.BASE_URL}/api/dashboard/performance`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setData(response.data.data);
    } catch (err) {
      console.error("Error al cargar estadísticas de rendimiento:", err);
      setError(
        err.response?.data?.message ||
          "Error al cargar estadísticas de rendimiento"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetch = () => {
    fetchData();
  };

  return { data, loading, error, refetch };
};
